/* eslint-disable camelcase */
<template >
  <div v-role="'func'">
    <br>
    <div>
      <div class="formPosition">
        <v-card style="margin:auto;" width="1200">
          <v-container style="background-color:#006699; color:white;"></v-container>
          <v-progress-linear v-if="progresso" indeterminate color="green" height="10"></v-progress-linear>

          <v-toolbar flat color="white">
            <v-btn @click="openDialog()" style="background-color:#006699;color:white;" outlined> <v-icon md color="white darken-2">add</v-icon> Reportar Nova Situação </v-btn>
            <v-divider class="mx-8" inset vertical></v-divider>
            <v-toolbar-title> Situações Reportadas </v-toolbar-title>
            <v-divider class="mx-8" inset vertical></v-divider>
            
            <!--  search  -->
            <div class="flex-grow-1"></div>
            <v-btn v-if="searchInDb" @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>
            <v-text-field v-model="searchInDb" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
            <!-- end  search  -->
          </v-toolbar>

          <template>
            <v-data-table :headers="headers" :search="searchInDb" :items="produtos" :items-per-page="8">
              <template v-slot:item.ord="{item}">
                <span style="font-weight:bold;"> {{ produtos.indexOf(item)+1 }}.</span>
              </template>



              <template v-slot:item.status="{item}">
                <span v-if="item.status === 1"> Pendente </span>
                 <span v-if="item.status === 2" style="color:green;"> Resolvida </span>
                 <span v-if="item.status === 3" style="color:red;"> Não resolvida </span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-menu :offset-x="offsetX" :offset-y="offsetY" bottom origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
                      <v-icon dark>menu</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item v-if="role === 'SUPER_USER'" @click="showEditarStatus(item)">
                      <v-icon color="blue">sync</v-icon> Actualizar Estado
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </template>
 



 <!-- ======================== DIALOGO NOVO ESTUDANTE ===================================== -->
          <v-dialog v-model="dialogActualizar" max-width="800px">
            <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Actualizar estado situação</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <label style="font-weight:bold;">Reportado por:</label><label>{{loggedUserName}}</label>
                    </v-col>
                    <v-col cols="12" md="12">
                      <label style="font-weight:bold;">Identificador:</label><label>{{1}}</label>
                    </v-col>
                     <v-col cols="12" md="12">
                      <label style="font-weight:bold;">Data/Hora : </label><label>{{datatime}}</label>
                    </v-col>
                     <v-col cols="12" md="12">
                          <v-textarea
                          v-model="editedItem.situacao"
                          :disabled="true"
                            outlined
                            ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6">
                      <label style="font-weight:bold;">Editar Estado:</label>
                      <v-combobox
                        v-model="model"
                        :items="Estados"
                        item-text="descricao"
                        outlined
                        return-object
                       >
                      </v-combobox>
                    </v-col>
                  </v-row>                 
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="black darken-1" text @click="dialogActualizar = false"> fechar </v-btn>
                  <v-btn color="green darken-1" text :disabled="editedItem.situacao ===''" @click="Guardar()"> Editar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- =================================================================================================== -->

        

          <!-- ======================== DIALOGO NOVO ESTUDANTE ===================================== -->
          <v-dialog v-model="dialog" max-width="800px">
            <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Reportar Nova Situação</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <label style="font-weight:bold;">Nome:</label><label>{{loggedUserName}}</label>
                    </v-col>
                     <v-col cols="12" md="12">
                      <label style="font-weight:bold;">Data/Hora : </label><label>{{datatime}}</label>
                    </v-col>
                    <v-col cols="12" md="6">
                      <label style="font-weight:bold;">Tipo de reporte:</label>
                      <v-combobox
                        v-model="model"
                        :items="tiposReporte"
                        item-text="descricao"
                        outlined
                        return-object
                       >
                      </v-combobox>
                    </v-col>
                     <v-col cols="12" md="12">
                          <v-textarea
                          v-model="editedItem.situacao"
                            outlined
                            name="input-7-4"
                            label="Queira por favor descrever a situação com o máximo de detalhes possível, incluindo o número de matrícula"
                          ></v-textarea>
                    </v-col>
                  </v-row>
                  
                 
                  <small>*Preencha correctamente os campos</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="black darken-1" text @click="dialog = false"> fechar </v-btn>
                  <v-btn color="green darken-1" text :disabled="editedItem.situacao ===''" @click="Guardar()"> Reportar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- =================================================================================================== -->

          <!-- =================================================================================================== -->
          <v-row justify="center">
            <v-dialog v-model="dialogoConcordar" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Essa operação irá afectar o sistema como um todo, por isso pergunto novamente tens realmente a certeza de que desejas continuar com essa operação?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogoConcordar = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="MudarTipoEstudante()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
          <!-- **************************************************************************************************** -->
        </v-card>
      </div>
    </div>
  </div>
</template>
My CRUD
<script>
import axiosPedagogico from '../../plugins/axiosFinancas'
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    cardBolseiro: false,
    mostrarOpcoesBolsa: false,
    tipoDeBolsa: '',
    descricaoBolseiro: '',
    tipoBolseiroOng: [],
    cardNovaOrganizacao: false,
    overlayOrganizacao: false,
    nomeNovaOrganizacao: '',
    idNovaOrganizacao: null,
    bolseiroSelected: null,
    valorDesconto: '',
    tipoBolseiroSelected: '',
    listaOngBolsas: [],
    tiposReporte:[
      {id:1,descricao:'Reportar Erro'},
      {id:2,descricao:'Sugerir Melhorias'}
    ],
    Estados:[
      {id:1,descricao:'Resolvida'},
      {id:2,descricao:'Não Resolvida'}
    ],
    ongBolsaSelected: null,
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    periodos: [
      { id: 'M', descricao: 'Manhã' },
      { id: 'T', descricao: 'Tarde' },
      { id: 'N', descricao: 'Noite' }
    ],
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    dialogActualizar: false,
    municipiosAll: [],
    produtos: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    searchInDb: '',
    estudantes: [],
    datatime: utilitarios.ObterDataActural()+'/'+utilitarios.ObterHoraActual(),
    classes: [],
    classesFiltered: [],
    recibos: [],
    servicos: [],
    dialogGrupo: false,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value => (value || '').length <= 70 || 'O máximo número de carácters atigidos',
      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [
      value => !!value || 'campo obrigatório.',
      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Ord.',
        align: 'start',
        sortable: false,
        value: 'ord'
      },
      { text: 'Identificador', value: 'id' },
      { text: 'Situação', value: 'situacao' },
      { text: 'Data registro', value: 'created_at' },
      { text: 'Reportado por', value: 'autor' },
      { text: 'Estado', value: 'status' },
      { text: 'Action', value: 'action' }
    ],
    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    overlay: false,
    estudanteObjecto: null,
    dialogoConcordar: false,
    editedItem: {
      pk_estudante:0,
      numeroProcesso: '',
      pkPessoa: 0,
      classeSelected: '',
      bi: '',
      idPessoa: '',
      municipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      situacao:'',
      email: '',
      sexo: '',
      periodo: '',
      nomedopai: '',
      nomedamae: '',
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      numeroProcesso: '',
      matriculaAntiga:''
    },
    defaultItem: {
      pk_estudante:0,
      numeroProcesso: '',
      pkPessoa: 0,
      classeSelected: '',
      bi: '',
      idPessoa: '',
      municipio: null,
      idPerfil: null,
      nome: '',
      periodo: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      numeroProcesso: '',
      matriculaAntiga:'',
    }
  }),

  computed: {
    loggedUserName() {
      return ls.get('nomeUsuario')
    },
    computeddatanascimento() {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns() {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    nivelEnsino() {
      return ls.get('nivel')
    },
    role() {
      return ls.get('role')
    },
    isAtlantidaOrMazozo() {
      return true//window.location.host.includes('ispatlantida.com') || window.location.host.includes('192.168.44.10') || window.location.host.includes('ispamazozo.com')
    }
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes() {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      try {
        this.progresso = true;
        this.produtos = await axios.get('/situacoesReportadasAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    async initializeProvincias() {
      try {
        this.progresso = true;
        this.provincias = await axios.get('/provinciaFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    async initializeCursos() {
      try {
        this.isLoading = true;
        this.cursos = await axiosPedagogico.get('/cursoInstituicaoFindAllIntegracao').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally { 
        this.isLoading = false;
      }
    },

    outroDoc() {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = '';
        this.descricao = 'Nº do Bi';
        this.mascara = '#########-AA-###';
        this.ruleBI = [ value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'];
      } else {
        this.editedItem.bi = '';
        this.descricao = 'Outro Doc.';
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
        this.ruleBI = [ value => value.length >= 6 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'];
      }
    },

    async mudarNovoEstudante(item) {
      this.estudanteObjecto = item;
      this.dialogoConcordar = true;
    },
    
    showEditarStatus(item) {
      this.editedItem = Object.assign(item)
      this.dialogActualizar = true;
    },

    async MudarTipoEstudante() {
      try {
        this.progresso = true;
        let resultado = await axios.post('/mudarTipoEstudante', { estudante: this.estudanteObjecto, tipo: 1 }).then(res => res.data);
        if (resultado.affectedRows >= 1) {
          this.dialogoConcordar = false;
          Swal.fire('Informação', '<p>Actualização efectuada com sucesso.</p>', 'success');
          this.initialize();
        }
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    async initializeClasses() {
      try {
        this.isLoading = true;
        this.classes = await axios.get('/classeFindAll2').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeTurmas() {
      try {
        this.isLoading = true;
        this.turmasAll = await axios.get('/turmasFindAlls').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeMunicipios() {
      try {
        this.progresso = true;
        this.municipiosAll = await axios.get('/municipioFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    // METHODO FOR VALIDATION
    validate() {
      if (this.$refs.form.validate()) {
      } else {
        console.log('elso foraaa')
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    close() {
      this.dialog = false
      this.$refs.form.resetValidation()
    },
    saveDate(date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi(datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(datebi).toISOString().substr(0, 10)
    },

    async Save() {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params = {
          pk_estudante: this.editedItem.pk_estudante,
          nome: this.editedItem.nome,
          nif: this.editedItem.nif,
          morada: this.editedItem.morada,
          telefone1: this.editedItem.telefone,
          telefone2: this.editedItem.telefone2,
          email: this.editedItem.email,
          observacao: this.editedItem.observacao,
          produtosDesconto: null,
          descontoPorProduto: null,
          OpcaodescontoGlobal: null,
          descontoGlobal: null
        }

        try {
          //   let  payload =""
          let msg = await axios.post('/clienteInsertOrUpdate', params).then(res => res.data)
          if (msg) {
            this.initialize()
            this.showAlert()
            //this.Limpar()
          }
        } catch (error) {
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        } finally {
          this.overlay = false;
        }
      }
    },

    showAlert() {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = 'Actualização efectuada com sucesso!'
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    Limpar() {
      this.editedItem.nome = '';
      this.editedItem.datanascimento = '';
      this.editedItem.nomedopai = '';
      this.editedItem.nomedamae = '';
      this.editedItem.dataemissaobi = '';
      this.editedItem.telefone = '';
    },

    openDialog() {
      this.dialog = true;
    },

    loadTurmaComb() {
      this.turmasFiltered = []
      this.editedItem.turma = null
      this.turmasFiltered = this.turmasAll.filter(t => t.curso_id === this.editedItem.curso.idCurso && t.classe_id === this.editedItem.classeSelected.pkAnoacademico)
    },

    loadMunicipioComb(provincia) {
      this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia);
    },

    loadclasse() {
      /**
       * Nivel Ensino
       * 1 - Superioor
       * 2 - Médio
       */
      if (this.nivelEnsino === 1) {
        for (let index = 1; index <= parseInt(this.editedItem.curso.numero_anos_academicos); index++) {
          this.classesFiltered.push({ id: index, descricao: index + 'º ano' })
        }
        this.classesFiltered.push({ id: 100, descricao: 'Monografia' })
      } else {
        let classe = 10
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({ id: index, descricao: classe + 'ª Classe' })
          classe++;
        }
      }
    },

    loadclasseEditar(numeroAnoAcademicos, anoacademicoEstudante) {
      /**
      * Nivel Ensino
      * 1 - Superioor
      * 2 - Médio
      */
      if (this.nivelEnsino === 1) {
        for (let index = 1; index <= parseInt(numeroAnoAcademicos); index++) {
          this.classesFiltered.push({ id: index, descricao: index + 'º ano' })
        }
        this.classesFiltered.push({ id: 100, descricao: 'Monografia' })
        this.editedItem.classeSelected = this.classesFiltered.filter(c => c.id === anoacademicoEstudante)[0]
      } else {
        let classe = 10
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({ id: index, descricao: classe + 'ª Classe' })
          classe++;
        }
      }
    },

    async Guardar() {
      if (this.$refs.form.validate()) {
        try {
          this.overlay = true;
          let params = {
             usuario: this.loggedUserName,
             situacao: this.editedItem.situacao
          }
          let result = await axios.post('reportarSituacao', params)
          if (result.data.affectedRows >= 1) {
            utilitarios.showAlertMessage('success', 'Situação reportada com  sucesso.')
            this.dialog = false;
            this.editedItem = this.defaultItem;
            this.initialize();
          } else if (result.data.status === 1122) { // For duplicate entry
            Swal.fire('Informação', '<p>Número do Bilhete ou Processo já registrado.</p>', 'warning')
          } else {
            utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
          }
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
        } finally { 
          this.overlay = false; 
        }
      }
    },

    /**
     * Método responsavél por carregar os dados que serão necessário para registrar um bolseiro.
     * Trás a lista das organizações provedoras de bolsa disponivel
     * Trás a lista de todos os tipos de bolseiros salvo no Banco de dados
     * Caso houver um erro durante a requisição, será exibida uma notificação.
    */
    async carregarDadosBolseiros() {
      try {
        this.progresso = true;
        this.listaOngBolsas = await axios.get('/listarOrganizacoesBolsas').then((res) => res.data);
        this.listaOngBolsas.unshift({ nome: 'Nova Organização', id: -1, icone: true });
        this.tipoBolseiroOng = await axios.get('/obterDescricaoBolseiros').then((res) => res.data);
      } catch (error) {
        console.log(error)
        utilitarios.showAlertMessage('error', 'Ocorreu um error durante o carregamento da página!')
      } finally {
        this.progresso = false;
      }
    },

    /**
     * Método responsavél tornar o cardBolseiro visivél.
     * Armazena os dados do estudante selecionado na variavél bolseiroSelected
    */
    async registrarBolseiro(estudante) {
      this.cardBolseiro = true;
      this.bolseiroSelected = estudante;
    },

     /**
     * Método responsavél tornar o cardBolseiro invisivél.
     * Reseta o valor das variaveis tipoBolseiroSelected, valorDesconto, ongBolsaSelected
    */
    fecharCardBolseiro() {
      this.tipoBolseiroSelected = null;
      this.valorDesconto = '';
      this.descricaoBolseiro = '';
      this.ongBolsaSelected = null;
      this.mostrarOpcoesBolsa = false;
      this.cardBolseiro = false;
    },

    /**
     * Método responsavél tornar o cardNovaOrganizacao visivél.
     * Verifica se o usuário clicou na opcção "Nova Organização"
     * Reseta o valor da variavel ongBolsaSelected
     * Fecha o cardBolseiro
    */
    SelecionarOrganizacao() {
      this.mostrarOpcoesBolsa = false;
      if (this.ongBolsaSelected.tipo_bolseiro == 1) {
        this.tipoDeBolsa = 1;
        this.valorDesconto = "100%";
        this.descricaoBolseiro = "Os bolseiros dessa natureza são isentos de mensalidades e multas.";
      } else if(this.ongBolsaSelected.tipo_bolseiro == 2) {
        this.tipoDeBolsa = 2;
        this.valorDesconto = "0%";
        this.descricaoBolseiro = "Os bolseiros dessa natureza estão isentos do pagamento de multas decorrentes de atrasos no pagamento.";
      } else {
        this.tipoDeBolsa = 3;
        this.tipoBolseiroSelected = "Comparticipada";
        this.valorDesconto = "50%";
        this.descricaoBolseiro = "Os bolseiros desta natureza possuem direito a um desconto de 50% no pagamento da mensalidade.";
        this.mostrarOpcoesBolsa = true;
      }

      if (this.ongBolsaSelected.id === -1) {
        this.cardNovaOrganizacao = true;
        this.ongBolsaSelected = null;
        this.fecharCardBolseiro();
      }
    },

    /**
     * Método responsavel por verificar se a organização já foi cadastrada.
     * Verica se o nome quee está a ser inserido já existe no banco de dados
     * Valida se o campo está vázio
     * Se a organização já for cadastrada antes, será exibido uma notificação
     * Se ainda não foi cadstrada, será chamado o método responsavél por cadastrar
    */

    async verificarOrganizacao() {
      if (this.$refs.form.validate() && this.nomeNovaOrganizacao) {
        let params = {
          nome: this.nomeNovaOrganizacao.trim()
        }
        let organizacaoExistente = await axios.post('/verificarOrganizacaoExistente', params).then((res) => res.data);
        if (organizacaoExistente.length) {
          utilitarios.showAlertMessage('error', 'Organização já registrada!')
        } else {
          this.saveNovaOrganizacao();
        }
      }
    },

    /**
     * Método responsavél por cadastrar a nova organização inserida.
     * Se o cadastro ocrrer com sucesso, fecha o cardNovaOrganizacao e chamará a função this.carregarDadosBolseiros();
     * Caso ocorra um erro durante o cadastramento, será exibido uma notificação
    */
    async saveNovaOrganizacao() {
      if (this.$refs.form.validate()) {
        let params = {
          tipo_bolseiro: this.idNovaOrganizacao.tipoBolseiro,
          nomeOrgazacao: this.nomeNovaOrganizacao.trim()
        }

        try {
          this.overlayOrganizacao = true;
          let result = await axios.post('/cadastrarNovaOrganizacao', params).then((res) => res.data);
          if(result.affectedRows >= 1) {
            utilitarios.showAlertMessage('success', 'Organização adicionada com sucesso!');
            this.fecharCardNovaOrganizacao();
            this.carregarDadosBolseiros();
            location.reload();
          }
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao adicionar a nova organização!')
        } finally {
          this.overlayOrganizacao = false;
        }
      }
    },

    /**
     * Método responsavél por fechar o cardNovaOrganizacao.
     * reseta o valor da variavél nomeNovaOrganizacao
    */
    fecharCardNovaOrganizacao() {
      this.nomeNovaOrganizacao = '';
      this.idNovaOrganizacao = null;
      this.cardNovaOrganizacao = false;
    },

    /**
     * Método responsavel por verificar se o bolseiro já foi cadastrado.
     * Verifica se o bilhete (nif) já existe na tabela bolseiros
     * Se o bolseiro já foi cadastrado antes, será exibido uma notificação
     * Se ainda não foi cadstrado, será chamado o método responsavél por cadastrar
    */
    async verificarBolseiroCadastrado() {
      if (this.$refs.form.validate()) {
        let params = {
          nif: this.bolseiroSelected.nif
        }
        let bolseiroExistente = await axios.post('/vericarBolseiroExistente', params).then((res) => res.data);
        if (bolseiroExistente.length) {
          utilitarios.showAlertMessage('error', 'Bolseiro já registrado!')
        } else {
          this.salvarBolseiro();
        }
      }
    },

    /**
     * Método responsavél por cadastrar umnovo bolseiro.
     * Se o cadastro correr com sucesso, fecha o fecharCardBolseiro e chamará a função this.initialize();
     * Caso ocorra um erro durante o cadastramento, será exibido uma notificação
    */
    async salvarBolseiro() {
      if (this.$refs.form.validate()) {
        let params = {
          nome: this.bolseiroSelected.nome,
          anoLectivo: this.bolseiroSelected.anolectivo,
          curso: this.bolseiroSelected.curso,
          nif: this.bolseiroSelected.nif,
          matricula: this.bolseiroSelected.numero_matricula,
          ongBolsa: this.ongBolsaSelected.nome,
          tipoBolsa: this.tipoDeBolsa,
          desconto: this.valorDesconto
        }
  
        try {
          this.overlay = true;
          let result = await axios.post('/registrarBolseiro', params).then((res) => res.data);
          if(result.affectedRows >= 0) {
            utilitarios.showAlertMessage('success', 'Bolseiro registrado com sucesso.')
            this.fecharCardBolseiro();
            this.initialize();
          }
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro durante o registro do bolseiro!');
        } finally {
          this.overlay = false;
        }
      }
    }
  }
}
</script>
<style scoped></style>
